<div class="wns-backdrop">
  <div class="wns-card" role="dialog" aria-modal="true" aria-labelledby="wns-title">
    <span class="wns-badge">New</span>
    <h2 class="wns-title" id="wns-title">All your settings, in one place</h2>
    <p class="wns-subtitle">
      To Go, Payments and your ordering &amp; kitchen switches now live together in
      <b>Restaurant → Settings</b>.
    </p>

    @for (key of [run]; track key) {
      <div class="wns-stage" aria-hidden="true">
        <!-- Before: three separate pages. -->
        <div class="mock mock-old mock-togo">
          <div class="mock-head"><i class="bx bx-shopping-bag"></i> To Go</div>
          <div class="mock-line"><span></span><b class="on"></b></div>
          <div class="mock-line"><span></span><b class="on"></b></div>
          <div class="mock-qr"></div>
        </div>
        <div class="mock mock-old mock-settings">
          <div class="mock-head"><i class="bx bx-cog"></i> Settings</div>
          <div class="mock-line"><span></span><b></b></div>
          <div class="mock-line"><span></span><b class="on"></b></div>
          <div class="mock-line"><span></span><b class="on"></b></div>
        </div>
        <div class="mock mock-old mock-payments">
          <div class="mock-head"><i class="bx bx-credit-card"></i> Payments</div>
          <div class="mock-line"><span></span><b class="on"></b></div>
          <div class="mock-line"><span></span><b class="on"></b></div>
          <div class="mock-line"><span></span><b class="on"></b></div>
        </div>

        <!-- After: one Settings page, Order beside Payment, Feature below. -->
        <div class="mock mock-new">
          <div class="mock-head"><i class="bx bx-cog"></i> Restaurant → Settings</div>
          <div class="mock-grid">
            <div class="mock-col">
              <div class="mock-section s-order">
                <em>Order</em>
                <div class="mock-line"><span></span><b></b></div>
                <div class="mock-line"><span></span><b class="on"></b></div>
                <div class="mock-sub">To Go</div>
                <div class="mock-line"><span></span><b class="on"></b></div>
                <div class="mock-qr small"></div>
              </div>
            </div>
            <div class="mock-col">
              <div class="mock-section s-payment">
                <em>Payment</em>
                <div class="mock-line"><span></span><b class="on"></b></div>
                <div class="mock-line"><span></span><b class="on"></b></div>
                <div class="mock-line"><span></span><b class="on"></b></div>
              </div>
              <div class="mock-section s-feature">
                <em>Feature</em>
                <div class="mock-line"><span></span><b class="on"></b></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    <ul class="wns-points">
      <li>
        <span class="wns-dot order"></span>
        <span><b>Order</b> — Dine-In, Online Ordering and To Go with its QR code.</span>
      </li>
      <li>
        <span class="wns-dot payment"></span>
        <span><b>Payment</b> — the payment methods your customers can use.</span>
      </li>
      <li>
        <span class="wns-dot feature"></span>
        <span><b>Feature</b> — Kitchen Display and other kitchen tools.</span>
      </li>
    </ul>
    <p class="wns-note">Old To Go and Payments links now open Settings.</p>

    <div class="wns-actions">
      <button type="button" class="wns-link" (click)="replay()">
        <i class="bx bx-revision"></i> Replay
      </button>
      <span class="wns-spacer"></span>
      <button type="button" class="btn btn-neutral rounded-3" (click)="dismiss.emit()">
        Got it
      </button>
      <button type="button" class="btn btn-dark rounded-3" (click)="openSettings.emit()">
        Open Settings
      </button>
    </div>
  </div>
</div>
